import type { VwfsType } from "@/prisma/generated/client";

export type VwfsLessorRef = {
  siretNumber: string;
  mdmNumber: string;
  atomiumNumber: string;
};

export const VWFS_LESSOR_SIRET_BY_TYPE: Record<VwfsType, VwfsLessorRef> = {
  LOUN: {
    siretNumber: "45161890400051",
    mdmNumber: "19695486",
    atomiumNumber: "1045028",
  },
  LLDFI: {
    siretNumber: "45161890400036",
    mdmNumber: "41820116",
    atomiumNumber: "1045018",
  },
  LOA: {
    siretNumber: "45161890400036",
    mdmNumber: "41820116",
    atomiumNumber: "1045018",
  },
  FINANCE_LEASE: {
    siretNumber: "45161890400036",
    mdmNumber: "41820116",
    atomiumNumber: "1045018",
  },
};

export function getVwfsLessorSiret(type: VwfsType): string {
  return VWFS_LESSOR_SIRET_BY_TYPE[type].siretNumber;
}

export function getVwfsLessorMdmNumber(type: VwfsType): string {
  return VWFS_LESSOR_SIRET_BY_TYPE[type].mdmNumber;
}

export const VWFS_LESSOR_SIRETS = Object.values(VWFS_LESSOR_SIRET_BY_TYPE).map(
  (lessor) => lessor.siretNumber,
);
